// import everything from autoload
import './autoload/_bootstrap.js' // eslint-disable-line

// import react habitat and react components
import './init/react'

// import styles from blocks

import '../gutenberg/blocks/accordion-item/styles.scss'; import '../gutenberg/blocks/accordion/styles.scss'; import '../gutenberg/blocks/anchor-nav/styles.scss'; import '../gutenberg/blocks/anchor/styles.scss'; import '../gutenberg/blocks/button/styles.scss'; import '../gutenberg/blocks/buttons/styles.scss'; import '../gutenberg/blocks/cpt-teaser-boxes/styles.scss'; import '../gutenberg/blocks/fact-wrapper/styles.scss'; import '../gutenberg/blocks/fact/styles.scss'; import '../gutenberg/blocks/floorplan/styles.scss'; import '../gutenberg/blocks/hero-stage/styles.scss'; import '../gutenberg/blocks/image-in-image-with-slider/styles.scss'; import '../gutenberg/blocks/image-text-carousel/styles.scss'; import '../gutenberg/blocks/reference-teaser/styles.scss'; import '../gutenberg/blocks/stage-l/styles.scss'; import '../gutenberg/blocks/stage-s/styles.scss'; import '../gutenberg/blocks/teaser-section/styles.scss'; import '../gutenberg/blocks/teaserbox/styles.scss'; import '../gutenberg/blocks/testimonial/styles.scss' // eslint-disable-line

//frontend blocks
import '../gutenberg/blocks/slider/frontend'
import '../gutenberg/blocks/accordion/functions'

// import local dependencies
import Router from './util/Router'
import common from './routes/common'
import home from './routes/home'
import aboutUs from './routes/about'

import { onDocumentReady } from './util/events'

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
})

// Load Events
onDocumentReady(() => routes.loadEvents())
